import * as v from 'valibot';

import { vcAccountId, vcAccountNumber, vcBmwOrMiniId, vcGcid, vcUcid } from '../../../../../utils/valibot/custom-types';
import { newSchema } from '../../../../../utils/valibot/schema';
import { RetailCrmNationalIdDocumentType } from './national-id-document-type.model';

export enum RetailCrmResponseSalutation {
  NONE = 'ANKEI',
  MR = 'ANHER',
  MRS = 'ANFRA',
  MX = 'ANMX',
  // GB/IE markets only
  DR = 'ANDR',
  MISS = 'ANMIS',
  MS = 'ANMS',
}

export enum RetailCrmResponseTitle {
  PROF = 'Prof.',
  DR = 'Dr.',
  PROF_DR = 'Prof. Dr.',
}

export enum RetailCrmCustomerMainType {
  ORGANIZATION = 'Organization',
  SELF_EMPLOYED = 'Self-Employed',
  INDIVIDUAL = 'Individual',
  DEALER = 'Dealer', // This will never occur in production, as it is only set for non-customer accounts
}

export const RetailCrmAddressSchema = newSchema(
  'RetailCrmAddressSchema',
  v.object({
    addressStreet: v.optional(v.string()),
    addressStreetNumber: v.optional(v.string()),
    addressPostalCode: v.optional(v.string()),
    addressCity: v.optional(v.string()),
    addressCountry: v.optional(v.string()),
    addressPostBox: v.optional(v.string()),
    addressState: v.optional(v.string()),
    addressComplement: v.optional(v.string()),
    addressLine2: v.optional(v.string()),
  }),
);

export const RetailCrmConnectionSchema = newSchema(
  'RetailCrmConnectionSchema',
  v.object({
    emailBusiness: v.optional(v.string()),
    emailPrivate: v.optional(v.string()),
    mobileBusiness: v.optional(v.string()),
    mobilePrivate: v.optional(v.string()),
    personHomePhone: v.optional(v.string()),
    personOtherPhone: v.optional(v.string()),
    phoneBusiness: v.optional(v.string()),
    phonePrivate: v.optional(v.string()),
  }),
);

export const RetailCrmNameSchema = newSchema(
  'RetailCrmNameSchema',
  v.object({
    personBirthdate: v.optional(v.string()),
    firstName: v.optional(v.string()),
    gender: v.optional(v.string()),
    initials: v.optional(v.string()),
    lastName: v.optional(v.string()),
    middleName: v.optional(v.string()),
    nationality: v.optional(v.string()),
    name: v.optional(v.string()),
    salutation: v.optional(v.enum(RetailCrmResponseSalutation)),
    suffix: v.optional(v.string()),
    title: v.optional(v.enum(RetailCrmResponseTitle)),
  }),
);

export const RetailCrmAccountSchema = newSchema(
  'RetailCrmAccountSchema',
  v.object({
    accountNumber: v.optional(vcAccountNumber),
    accountId: v.optional(vcAccountId),
    gcid: v.optional(vcGcid),
    ucid: v.optional(vcUcid),
    customerMainType: v.optional(v.enum(RetailCrmCustomerMainType)),
    bmwOrMiniId: v.optional(vcBmwOrMiniId),
    businessAddress: v.optional(RetailCrmAddressSchema),
    connection: v.optional(RetailCrmConnectionSchema),
    name: v.optional(RetailCrmNameSchema),
    privateAddress: v.optional(RetailCrmAddressSchema),
    taxNumber: v.optional(v.string()),
    nationalId1: v.optional(v.string()),
    nationalId1DocumentType: v.optional(v.enum(RetailCrmNationalIdDocumentType)),
    correspondenceLanguage: v.optional(v.string()),
    inSyncWithDirectSales: v.optional(v.boolean()),
  }),
);

export const RetailCrmAccountsResponseSchema = newSchema(
  'RetailCrmAccountsResponseSchema',
  v.array(RetailCrmAccountSchema),
);

export type RetailCrmAddress = v.InferOutput<typeof RetailCrmAddressSchema>;
export type RetailCrmConnection = v.InferOutput<typeof RetailCrmConnectionSchema>;
export type RetailCrmName = v.InferOutput<typeof RetailCrmNameSchema>;
export type RetailCrmAccount = v.InferOutput<typeof RetailCrmAccountSchema>;
export type RetailCrmAccountsResponse = v.InferOutput<typeof RetailCrmAccountsResponseSchema>;
